WiseMetering.Views.DestroyInvoice = WiseMetering.Views.Modal.Destroy.extend({
    title: () => i18next.t('modal.title.invoices.destroy')
});
